// extracted by mini-css-extract-plugin
export default {"container":"chat-input_container__nQ1bQ","input_container":"chat-input_input_container__1PNEl","input":"chat-input_input__mr5cc","button":"chat-input_button__mp2zh"};